module.exports = __webpack_public_path__ + "img/md-light-indigo.52bfe829.svg";